import { useContext } from "react";
import { SignContext } from "../contexts/sign-context";

export const useSign = () => useContext(SignContext);
